import React from "react";
import { Modal } from "reactstrap";
import MultipleInvoiceForm from "./MultipleInvoicesForm";

const MultipleInvoiceModal = ({ program, isOpen, setOpen, toggle }) => {
  const props = { btnLabel: "Create Multiple Invoices", program, toggle };

  return (
    <Modal
      className="program-settings modal-2col modal-lg"
      isOpen={isOpen}
      toggle={() => setOpen(true)}
    >
      <div className="left">
        <div className="modal-2col__left-head">
          <span className="modal-2col__eyebrow">Billing</span>
          <h3 className="modal-2col__title">Multiple Invoices</h3>
          <p className="modal-2col__description">
            Enter funding amounts for multiple programs in one pass. After the
            invoices are created, you can review the results and generate a
            combined invoice summary for reconciliation.
          </p>
        </div>
      </div>

      <div className="right">
        <button type="button" className="modal-2col__close" onClick={toggle} aria-label="Close">
          Close
        </button>
        <MultipleInvoiceForm {...props} />
      </div>
    </Modal>
  );
};

export default MultipleInvoiceModal;
